const JobsStart = {
  components: {
    'jobs-list': JobsList,
  },
  data() {
    return {
      data: {
        docs: [],
        nextPage: 1,
        totalDocs: 0,
      },
      loading: false,
    };
  },
  computed: {
    hasPending() {
      return (
        this.data.docs.filter((job) => {
          return job.status == 'pending';
        }).length > 0
      );
    },
  },
  created() {
    this.loadMore();
  },
  methods: {
    loadMore() {
      if (this.loading) return false;
      if (!this.data.nextPage) return false;

      this.loading = true;
      this.$dmtk.jobs.get(this.data.nextPage).then((data) => {
        data.jobs.docs = this.data.docs.concat(data.jobs.docs);
        this.data = data.jobs;
        this.loading = false;
      });
    },
  },
  template: `
      <div>

      <h1 class="uk-h3 uk-margin-top">Tus ofertas publicadas</h1>
      <p>
        Desde aquí podrás gestionar todas las ofertas de empleo que has publicado en Doméstiko.
      </p>

      <div
          v-if="!loading && data.totalDocs === 0"
          class="uk-grid uk-flex-middle uk-margin-large-bottom">
        <div class="uk-width-auto">
          <img src="/assets/img/drawn/empty.svg" alt="Mensajes"/>
        </div>
        <div class="uk-width-expand">
          <h3 class="uk-text-bold">Todavía no has publicado ningún anuncio de empleo</h3>
        </div>
      </div>
      
      <div class="uk-alert uk-alert-warning" v-if="hasPending">
        Tienes alguna oferta pendiente de revisar por nuestros editores, 
        te mandaremos un correo electrónico cuando se aprueben.
      </div>

      <jobs-list 
	      :data="data" 
	      v-if="data.totalDocs > 0"
        v-scroll-loading="loadMore"
      ></jobs-list>

      <router-view></router-view>

      <div class="uk-text-center uk-margin-medium-top uk-margin-medium-bottom">
        <router-link to="empleo/nuevo" class="uk-button uk-button-dmtk">
          Publicar más ofertas de trabajo
        </router-link>
      </div>

      </div>
	`,
};
